import React, { useState, useContext, useEffect } from "react";

import { Grid, Card, Typography, Button } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import MonitoringContext from "../../context/monitoring/MonitoringContext";

import MonitoringLatestOrder from "./MonitoringLatestOrder";
import MonitoringDuplicatedEmail from "./MonitoringDuplicatedEmail";
import MonitoringMissingPayments from "./MonitoringMissingPayments";
import MonitoringPendingPayments from "./MonitoringPendingPayments";

const MonitoringHome = () => {
  const monitoringContext = useContext(MonitoringContext);
  const {
    getMonitorings,
    getDuplicated,
    getMissingPayments,
    getPendingPayments,
  } = monitoringContext;

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    card: {
      padding: theme.spacing(2),
      height: 600,
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    getMonitorings();
    getDuplicated();
    getMissingPayments();
    getPendingPayments();
  }, []);

  return (
    <div className={classes.root}>
      <Grid container direction="row" spacing={2}>
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h4"> Monitoring </Typography>{" "}
          </Grid>{" "}
        </Grid>{" "}
        <Grid item xs={6}>
          <MonitoringLatestOrder />
        </Grid>{" "}
        <Grid item xs={6}>
          <MonitoringDuplicatedEmail />
        </Grid>{" "}
        <Grid item xs={6}>
          <MonitoringMissingPayments />
        </Grid>{" "}
        <Grid item xs={6}>
          <MonitoringPendingPayments />
        </Grid>{" "}
      </Grid>{" "}
    </div>
  );
};

export default MonitoringHome;
